import InfiniteScroll from 'react-infinite-scroll-component';
import styled, { css } from 'styled-components';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ExportNotificationHighlightsRequest,
  NotificationAlerts,
  NotificationHighlightsExportTimeRange
} from 'Types/CompaniesTypes';
import { Filter } from 'Types/FilterTypes';
import { exportFilterOptions, feedsHighlightsFilterOptions, getEmail, MidWidthApp1200, IsMobile, valueToObject } from 'Utils/UtilityFunctions';
import Button from 'antd/es/button';
import Checkbox from 'antd/es/checkbox';
import Spin from 'antd/es/spin';
import NoDataFound from 'Components/common/components/NoDataFound';
import {
  boxShadow,
  greyColor,
  maxMobile,
  maxTablet, maxWidth, primaryColor, primaryFont, primaryHeadingColor, retina, secondaryFont, wLight, wMBold, wMedium
} from 'Utils/utilsStyle';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { actions as alertActions } from '../../../Slice/AlertsSlice';
import {
  selectFeedNotificationLoading,
  selectFeedPeopleNotification,
  selectFeedPeopleMessage,
  selectFeedNotificationPage,
  selectFeedNotificationsEnded,
  selectExportNotificationHighlightsLoading,
} from '../../../Selector/AlertsSelector';
import PopoverButton from '../../common/popover/PopoverButton';
import ExportIcon from '../../common/assets/svgIcons/ExportIcon';
import classNames from 'classnames';
import FilterIcon from '../../common/assets/svgIcons/FilterDarkIcon';
import FeedHighlightsSkeleton from '../../common/skeleton/FeedHighlightsSkeleton';
import { PriorityIcon } from '../../../Components/common/assets/svgIcons/PriorityIcon';
import { GoodFitIcon } from '../../../Components/common/assets/svgIcons/GoodFitIcon';
import { WatchIcon } from '../../../Components/common/assets/svgIcons/WatchIcon';
import { actions as flurryActions } from 'Slice/HelperSlice';
import FeedHighlightsNotification from '../components/FeedHighlightsNotification';


const PEOPLE_FILTERS: Filter[] = [
  {
    filterId: '913',
    filterName: 'People Role Update',
    filterColor: 'null',
    subFilterId: 'None',
    filterTypeName: 'peopleNotification',
    isSelected: true,
  },
];

const tooltipTextStyle = css`
  color: #000;
  font-family: ${primaryFont};
  font-size: 14px;
  font-weight: ${wLight};
  line-height: 16px;
`

const Wrapper = styled.div`
height: 670px;
@media all and (max-width: ${maxMobile}) {
  height: 500px;
}
 display: flex;
 flex-direction: column;
 justify-content: space-between;
 box-shadow : ${boxShadow};
 background-color: #fff;
 border-radius: 12px;
 .articles-wrapper {
  height: calc(100% - 50px) !important;
  margin: 20px 24px 0px 24px;
  padding-right: 6px;
  @media all and (min-width: 1680px) {
    height: calc(100% - 60px) !important;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    height: calc(-50px + 100%) !important;
    margin: 20px 24px 0px 24px;
  }
  @media all and (max-width: ${maxTablet}) {
    height: calc(-50px + 100%) !important;
    margin: 20px 10px 0px 10px;
  }
  @media all and (max-width: ${maxMobile}) {
    height: calc(-50px + 100%) !important;
    margin: 20px 10px 0px 10px;
  }
 }
 .inner-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px 0px 8px;
    .header-wrapper {
      padding: 0px 24px;
      height: auto;
      @media all and (max-width: ${maxTablet}) {
        padding: 0 10px;
        width: 100% !important;
      }
      .heading-text {
        font-size: 28px;
        font-family: ${secondaryFont};
        font-weight: ${wMBold};
        color: ${primaryHeadingColor};
        @media all and (max-width: ${maxWidth}), ${retina}{
          font-size: 20px;
        }
        @media all and (max-width: ${maxTablet}) {
          font-size: 15px;
        }
      }
      .filters-wrapper {
        gap: 8px; 
        .export-svg {
          width: 14px;
          height: 12px;
        }
        .filter-icon-dropdown {
          width: 15px;
          height: 14px;
        }
        .ant-popover {
          width: auto !important;
          max-width: 100% !important;
          z-index: 1 !important;
          .ant-popover-inner {
            padding: 12px 24px !important;
            background-color: #F8F8F8 !important;
            .ant-popover-inner-content {
              width: 100% !important;
              height: auto !important;
            }
          }
        }
        .highlights-filter {
          .filter-header-wrapper {
            background-color: #fff;
            border-radius: 8px;
            padding: 10px 24px;
            .text {
              color: ${primaryHeadingColor};
              font-family: ${secondaryFont};
              font-size: 20px;
              font-weight: ${wMBold};
              margin-left: 4px;
            }
          }
          .ant-popover {
            width: 264px !important;
            .ant-popover-inner {
              padding: 0px !important;
            }
          }
        } 
      }
      .feed-highlights-tooltip-wrapper {
        .tooltip-text {
          ${tooltipTextStyle}
        }
        .tooltip-signal-wrapper {
          display: grid;
          gap: 8px;
          margin-top: 12px;
          .signal {
            .signal-text {
              ${tooltipTextStyle}
              font-size: 12px;
            }
            .signal-1 {
                color: #C10007;
              }
            .signal-2 {
                color: #A65F00;
              }
            .signal-3 {
                color: #1447E6;
              }
            .signal-1, .signal-2, .signal-3 {
                margin-bottom: 2px;
                font-size: 12px;
                font-weight: ${wMBold};
              }
            }
          } 
        }
      }
    }
    .infinite-scroll-component__outerdiv {
      height: 100%;
    }
    .no-test-message .no_data_found {
      height: 100%;
    }
    .export-filter-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .export-filter-item {
        color: ${greyColor};
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        letter-spacing: -0.4px;
        cursor: pointer;
        &:hover {
          color: ${primaryColor};
        }
        &.disabled {
          opacity: 0.6;
          pointer-events: none;
        }
      }
    }
    .highlights-filter-content {
      display: flex;
      flex-direction: column;
      .highlights-filter-item {
        color: ${greyColor};
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        letter-spacing: -0.4px;
        cursor: pointer;
        &.active {
          color: ${primaryColor};
        }
      }
      .filter-header-wrapper {
        svg {
          width: 15px;
          height: 14px;
        }
        .apply-btn {
          display: inline-block;
          border-radius: 8px;
          background-color: ${primaryColor};
          color: #fff;
          font-size: 16px;
          font-family: Roboto;
          font-weight: ${wMBold};
          cursor: pointer;
          &:hover {
            border-color: ${primaryColor} !important;
            background-color: transparent !important;
            color: ${primaryColor} !important;
          }
        }
        .disabled-btn {
          opacity: 0.6;
          pointer-events: none;
        }
      }
      .filter-options-wrapper {
        gap: 12px;
        margin: 16px 24px;
        .ant-checkbox-wrapper {
          margin-bottom: 0;
          align-items: center;
          &:hover .ant-checkbox-inner,
          .ant-checkbox:hover .ant-checkbox-inner {
            border-color: ${primaryColor} !important;
          }
          /* Focus state (keyboard users) */
          .ant-checkbox-input:focus + .ant-checkbox-inner {
            border-color: ${primaryColor} !important;
          }
          /* Checked state */
          .ant-checkbox-checked .ant-checkbox-inner {
            border-color: ${primaryColor} !important;
          }
          /* Checked + hover */
          &:hover .ant-checkbox-checked .ant-checkbox-inner {
            border-color: ${primaryColor} !important;
          }
        }
      }
    }
`

const SkeletonWrapper = styled.div`
  display: grid;
  gap: 30.5px;
  box-shadow : ${boxShadow};
  background-color: #fff;
  height: 670px;
  width: auto;
  padding: 16px 24px 28px 24px;
  border-radius: 12px;
`

const Highlights = function Highlights() {
  const isMobile = IsMobile();
  const dispatch = useDispatch();
  const isDesktop1200 = MidWidthApp1200();
  const notificationLoading: boolean = useSelector(selectFeedNotificationLoading);
  const peopleNotification: NotificationAlerts[] = useSelector(selectFeedPeopleNotification);
  const message: string = useSelector(selectFeedPeopleMessage);
  const notificationPage: number = useSelector(selectFeedNotificationPage);
  const notificationEnded: boolean = useSelector(selectFeedNotificationsEnded);
  const exportNotificationHighlightsLoading: boolean = useSelector(selectExportNotificationHighlightsLoading);
  const [activeExportType, setActiveExportType] = useState(0);
  const [selectedValues, setSelectedValues] = useState<string[]>(['ALL']);
  const [openAlertFilter, setOpenAlertFilter] = useState(false);
  const [openExportFilter, setOpenExportFilter] = useState(false);
  const isFilterActive = !(selectedValues.length === 1 && selectedValues.includes('ALL'));
  const [appliedSelectedValues, setAppliedSelectedValues] = useState<string[]>(['ALL']);
  const hideHighlightsFilter = appliedSelectedValues.includes('ALL') && !notificationLoading && peopleNotification.length === 0;
  const isApplyDisabled = JSON.stringify(selectedValues.sort()) === JSON.stringify(appliedSelectedValues.sort());
  const host = window.location.href;

  const priorityFilterForExport = useMemo(() => {
    const selectedNonAllValues = selectedValues.filter((value) => value !== 'ALL');
    return selectedNonAllValues.length ? selectedNonAllValues.join(',') : 'ALL';
  }, [selectedValues]);

  const highlightsListing = useCallback((priorityFilter: string[]) => {
    const data: { username: string, page: number, filter: Filter[], isGilroyInsight: boolean, priorityFilter: string[] } = {
      username: getEmail() || '',
      page: 1,
      filter: PEOPLE_FILTERS,
      isGilroyInsight: true,
      priorityFilter
    };
    dispatch(alertActions.getFeedNotificationAlerts(data));
  }, [dispatch]);

  useEffect(() => {
    highlightsListing(['ALL']);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('Highlight_Section_Viewed', 0, { tags_input: 'Person', host })
    ));
  }, []);

  const fetchMoreNotifications = () => {
    const data = {
      username: getEmail() || '',
      page: notificationPage,
      filter: PEOPLE_FILTERS,
      isGilroyInsight: true,
      priorityFilter: appliedSelectedValues
    };
    dispatch(alertActions.getFeedNotificationAlerts(data));
  };

  const getTimeRangeFromOption = (value: string): NotificationHighlightsExportTimeRange => {
    const parsedRange = value.match(/\d+/)?.[0] as NotificationHighlightsExportTimeRange | undefined;
    return parsedRange || '1';
  };

  const handleExport = useCallback((value: string, index: number) => {
    const payload: ExportNotificationHighlightsRequest = {
      timeRange: getTimeRangeFromOption(value),
      priorityFilter: priorityFilterForExport,
    };

    setActiveExportType(index);
    dispatch(alertActions.exportNotificationHighlights(payload));
    setOpenExportFilter(false);
  }, [dispatch, priorityFilterForExport]);

  const ExportFilterContent = () => (
    <div className="export-filter-content">
      {exportFilterOptions.map((item, index) => (
        <div
          key={index}
          className={classNames('export-filter-item', {
            active: activeExportType === index,
            disabled: exportNotificationHighlightsLoading,
          })}
          onClick={() => {
            if (exportNotificationHighlightsLoading) {
              return;
            }
            handleExport(item.value, index);
          }}
          role="button"
          tabIndex={0}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
  const HighlightTypeFilterContent = () => {
    return (
      <div className="highlights-filter-content">
        <div className='filter-header-wrapper d-flex align-items-center justify-content-between'>
          <span className='d-flex align-items-center'>
            <FilterIcon />
            <span className='text'>Filter</span>
          </span>
          <span>
            <Button
              onClick={() => {
                if (isApplyDisabled) return;
                setAppliedSelectedValues(selectedValues);
                highlightsListing(selectedValues);
                setOpenAlertFilter(false);
              }}
              className={`apply-btn ${selectedValues.length === 0 || isApplyDisabled ? 'disabled-btn' : ''}`}
            >
              Apply
            </Button>
          </span>
        </div>

        <div className='filter-options-wrapper d-flex flex-column'>
          {feedsHighlightsFilterOptions.map((item, index) => {
            const isChecked = selectedValues.includes(item.value);
            return (
              <Checkbox
                key={index}
                checked={isChecked}
                onChange={() => {
                  if (item.value === 'ALL') {
                    if (selectedValues.includes('ALL')) {
                      setSelectedValues([]);
                    } else {
                      setSelectedValues(['ALL']);
                    }
                  } else {
                    let updated = selectedValues.filter(v => v !== 'ALL');

                    if (updated.includes(item.value)) {
                      updated = updated.filter(v => v !== item.value);
                    } else {
                      updated.push(item.value);
                    }

                    setSelectedValues(updated);
                  }
                }}
              >
                <div
                  className={classNames('highlights-filter-item', {
                    active: isChecked,
                  })}
                  role="button"
                  tabIndex={0}
                >
                  {item.label}
                </div>
              </Checkbox>
            );
          })}
        </div>
      </div>
    )
  };

  const highlightsTooltipContent = () => (
    <div className='feed-highlights-tooltip-wrapper'>
      <div className='tooltip-text'>
        <b>Stay in the Know</b> – Your <b>Highlights</b> panel brings
        together timely alerts like CXO moves, team note
        reminders, key updates, and smart signals like
        High Priority, Good Fit, and Watch all in one place.
      </div>
      <div className='tooltip-signal-wrapper'>
        <div className='signal d-flex flex-column'>
          <span className='signal-1 d-flex align-items-center'><PriorityIcon /> High priority</span>
          <span className='signal-text'>Strong opportunity key decision-makers (CXOs, VPs, top Directors) are involved. </span>
        </div>
        <div className='signal d-flex flex-column'>
          <span className='signal-2 d-flex align-items-center'><GoodFitIcon />  Good Fit</span>
          <span className='signal-text'>This looks relevant mid-level roles like VPs or Senior Managers are involved. </span>
        </div>
        <div className='signal d-flex flex-column'>
          <span className='signal-3 d-flex align-items-center'><WatchIcon /> Watch</span>
          <span className='signal-text'>Limited signals from junior roles. Best to keep this under observation. </span>
        </div>
      </div>
    </div >
  )

  return (
    <>
      {notificationLoading ? (
        <SkeletonWrapper>
          <FeedHighlightsSkeleton count={7} />
        </SkeletonWrapper>
      ) : (
        <Wrapper>
          <div className="inner-wrapper">
            <div className="header-wrapper d-flex align-items-center justify-content-between">
              <div className='heading-text d-flex align-items-center'>
                Highlights
                <span>
                  <HeadingWithToolTip
                    heightIconXSm="17px"
                    toolTipText={highlightsTooltipContent()}
                    toolPlacement={`${isDesktop1200 ? 'bottomLeft' : 'bottomRight'}`}
                  />
                </span>
              </div>
              {!hideHighlightsFilter &&
                <div className='filters-wrapper d-flex align-items-center'>
                  <div className='highlights-filter'>
                    <PopoverButton
                      open={openAlertFilter}
                      setOpen={setOpenAlertFilter}
                      isSuffix
                      icon={<FilterIcon />}
                      variant='iconTextDropdown'
                      text={isMobile ? '' : 'Filter'}
                      width={isMobile ? 'auto' : '128px'}
                      content={HighlightTypeFilterContent()}
                      placement="bottomRight"
                      isActive={isFilterActive}
                    />
                  </div>
                  <div className='export-filter'>
                    <PopoverButton
                      open={openExportFilter}
                      setOpen={setOpenExportFilter}
                      isSuffix
                      icon={<ExportIcon />}
                      variant='suffix'
                      text={isMobile ? '' : 'Export'}
                      width={isMobile ? 'auto' : '98px'}
                      content={ExportFilterContent()}
                      placement="bottomRight"
                    />
                  </div>
                </div>
              }
            </div>
            {peopleNotification?.length > 0 ? (
              <InfiniteScroll
                dataLength={peopleNotification.length}
                next={fetchMoreNotifications}
                hasMore={!notificationEnded}
                loader={<span className="spin-wrap"><Spin /></span>}
                className="o-x-hidden articles-wrapper"
                height="auto"
              >
                {peopleNotification?.map((notification: NotificationAlerts) => (
                  <div key={notification?.personId}>
                    <FeedHighlightsNotification
                      isRead={notification?.readFlag}
                      notification={notification}
                      closeDrawer={() => { }}
                    />
                  </div>
                ))}
              </InfiniteScroll>
            ) : (
              <div className="no-test-message">
                <NoDataFound title="No highlights available" />
              </div>
            )}
          </div>
        </Wrapper>
      )}
    </>
  );
};

export default Highlights;